import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { objectToCamel, objectToSnake } from 'ts-case-convert';
import { IHolidayCalendar } from 'src/app/models';
import { HolidayCalendarsHttpService } from './holiday-calendars.http.service';

@Injectable({
  providedIn: 'root'
})
export class HolidayCalendarsService {

  constructor(private holidayCalendarsHttpService: HolidayCalendarsHttpService) { }

  private extractList(data: any): IHolidayCalendar[] {
    const inner = data && !Array.isArray(data) && 'data' in data ? data.data : data;
    if (Array.isArray(inner)) return inner;
    if (inner && Array.isArray(inner.content)) return inner.content;
    if (inner && Array.isArray(inner.holidayCalendars)) return inner.holidayCalendars;
    console.warn('Unexpected holiday calendars response shape:', data);
    return [];
  }

  async getHolidayCalendarsByClientId(clientId: number, search?: string, page?: number, size?: number): Promise<IHolidayCalendar[]> {
    const source$ = this.holidayCalendarsHttpService.getHolidayCalendarsByClientId(clientId, search, page, size);
    const response = await lastValueFrom(source$);
    const data = objectToCamel(response as object) as any;
    return this.extractList(data);
  }

  async getHolidayCalendars(search?: string, page?: number, size?: number): Promise<IHolidayCalendar[]> {
    const source$ = this.holidayCalendarsHttpService.getHolidayCalendars(search, page, size);
    const response = await lastValueFrom(source$);
    const data = objectToCamel(response as object) as any;
    return this.extractList(data);
  }

  async getHolidayCalendar(id: number): Promise<IHolidayCalendar> {
    const source$ = this.holidayCalendarsHttpService.getHolidayCalendar(id);
    const response = await lastValueFrom(source$);
    return objectToCamel(response as object) as IHolidayCalendar;
  }

  async createHolidayCalendar(holidayCalendar: any): Promise<IHolidayCalendar> {
    const requestBody = objectToSnake(holidayCalendar);
    const source$ = this.holidayCalendarsHttpService.createHolidayCalendar(requestBody);
    const response = await lastValueFrom(source$);
    return objectToCamel(response as object) as IHolidayCalendar;
  }

  async updateHolidayCalendar(id: number, holidayCalendar: any): Promise<IHolidayCalendar> {
    const requestBody = objectToSnake(holidayCalendar);
    const source$ = this.holidayCalendarsHttpService.updateHolidayCalendar(id, requestBody);
    const response = await lastValueFrom(source$);
    return objectToCamel(response as object) as IHolidayCalendar;
  }

  async deleteHolidayCalendar(id: number): Promise<void> {
    const source$ = this.holidayCalendarsHttpService.deleteHolidayCalendar(id);
    await lastValueFrom(source$);
  }
}
